import { HttpResponseStatusCodes } from '@hobt/constants';
import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { config } from '../../../../../../../config';
import { decisionOverrideRationalesMapper } from './Mapper/DecisionOverrideRationalesMapper';
import { DecisionOverrideRationales, LoanDetails } from './types';
import { ValidationRemarkPayload } from 'Feature/V2/HbtMasterPool/components/HbtMasterPool/component/ForceStatusFlyout/types';

type RequestProps = {
  authenticationContext: AuthenticationContextType;
  data: { loansId: string };
};

type RequestLoansDecisionOverrideProps = {
  authenticationContext: AuthenticationContextType;
  request: ValidationRemarkPayload;
};
const apiClientConfig: ApiClientConfig = {
  timeout: config.validationReviewInventoryApi.requestTimeout
};
const inventoryTimeout: number = config.validationReviewInventoryApi.requestTimeout;
const validationInventoryDataUrl: string =
  config.validationReviewInventoryApi.urls.validationReview;
const insuredApprovedLenderListUrl: string =
  config.validationReviewInventoryApi.urls.insuredApprovedLenderList;

const individualLoanDetailsUrl: string =
  config.validationReviewInventoryApi.urls.loanInventoryTabDetails;
export const getIndividualLoanDetailsData = async ({
  authenticationContext,
  data
}: RequestProps): Promise<LoanDetails | null> => {
  try {
    const requestUrl = `${individualLoanDetailsUrl}/loans/${data.loansId}/details`;
    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      requestUrl
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data?.[0]) ||
      {}
    );
  } catch (err) {
    throw new Error('Error getting Individual Loan Details data');
    // eslint-disable-next-line no-unreachable
    return null;
  }
};

export const getDecisionOverrideRationales = async ({
  authenticationContext
}: {
  authenticationContext: AuthenticationContextType;
}): Promise<DecisionOverrideRationales[] | null> => {
  try {
    const requestUrl = `${individualLoanDetailsUrl}/loans/decision-override-rationales`;
    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      requestUrl
    );
    return (
      (response?.data?.statusCode === HttpResponseStatusCodes.OK && response?.data?.data) || {}
    );
  } catch (err) {
    throw new Error(`Error getting Decision Override Rationales data - ${err}`);
  }
};

export const setDecisionOverride = async ({
  authenticationContext,
  request
}: RequestLoansDecisionOverrideProps): Promise<void> => {
  try {
    const requestUrl = `${individualLoanDetailsUrl}/loans/decision-overrides`;
    const response = await ApiClient(authenticationContext, apiClientConfig).postWithAuth(
      requestUrl,
      request
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    throw err.response.data;
  }
};

export const patchDecisionOverride = async ({
  authenticationContext,
  request
}: RequestLoansDecisionOverrideProps): Promise<void> => {
  try {
    const requestUrl = `${individualLoanDetailsUrl}/loans/decision-overrides`;
    const response = await ApiClient(authenticationContext, apiClientConfig).patchWithAuth(
      requestUrl,
      request
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    return err.response.data;
  }
};
